import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../common/FormBase';
import Form from './Form';
import { makeInitialState } from '../../../helpers/FormHelper';
import { FIELDS } from './validation/fields';
import { schema } from './validation/schema';
import useQuery from '../../../hooks/useQuery';

const Debit = ({ ...props }) => {
  const { mobile, motiveId, issueForm, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);
  const [validLength] = useState(14);
  const query = useQuery();

  const rut = query.get('rut');
  const clientName = query.get('nombre_cli');
  const phone = query.get('telefono');
  const email = query.get('correo');
  const orderId = query.get('oc');
  const cud = query.get('cud');
  const aurisTicketId = query.get('aurisTicket');

  const fieldsQueryString = FIELDS.map((field) => {
    const objectValue = {
      rut,
      nombre_cli: clientName,
      telefono: phone,
      correo: email,
      oc: orderId,
      cud,
      aurisTicketId,
    };
    const defaultValue = '';
    return { ...field, value: objectValue[field.name] || defaultValue };
  });

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        issueForm={issueForm}
        mobile={mobile}
        title=""
        schema={schema}
        data={data}
        fields={fieldsQueryString}
        formName="Debit"
        makeInitialState={makeInitialState}
        onState={onState}
        motiveId={motiveId}
        typeId={typeId}
        validLength={validLength}
        onValid={handleValid}
        form={
          <Form
            issueForm={issueForm}
            mobile={mobile}
            state={state}
            makeInitialState={makeInitialState}
            onData={handleData}
            valid={valid}
            motiveId={motiveId}
            fields={fieldsQueryString}
          />
        }
      />
    </React.Fragment>
  );
};

Debit.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueForm: PropTypes.bool,
  typeId: PropTypes.string,
};

export default Debit;
